/*eslint-env browser */
import * as React from 'react'
import * as styles from './profile.settings.styl'
import cx from 'classnames'
import AccountSettings from '../account.settings'
import { useSelector } from 'react-redux'
import type { History } from 'history'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { HelpLink } from '../help.link'
import { UserRightsEnum } from '@src/utils/user.rights'
import { useEffect, useRef } from 'react'
import * as CommonSelectors from '@src/selectors'
import { useOnlineStatus } from '../../../online.status'
import { useOutsideClick } from '@src/hooks/use-outside-click-hook'

export const ProfileSettingsCSSSelectors = {
  loggedUser: new CSSSelector('logged-user')
}

interface OwnProps {
  history: History
  onOpenAboutUs: () => void
}
export type Props = OwnProps
interface State {
  showSettingsMenu: boolean
}

const ProfileSettings: React.FC<Props> = (props: Props) => {
  const { onOpenAboutUs, history } = props
  const user = useSelector(CommonSelectors.getUser)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const isOnline = useOnlineStatus()
  const [state, setState] = React.useState<State>({
    showSettingsMenu: false
  })

  useEffect(() => {
    document.addEventListener('mouseout', handleClickOutside)
    return () => document.removeEventListener('mouseout', handleClickOutside)
  }, [])

  function signOut() {
    history?.push('/logout')
  }

  function handleClickOutside(event: MouseEvent) {
    if (
      wrapperRef &&
      state.showSettingsMenu &&
      !wrapperRef.current?.contains(event.target as Node)
    ) {
      setState({ showSettingsMenu: false })
    }
  }

  function showHideMenu(e) {
    setState({ showSettingsMenu: !state.showSettingsMenu })

    e.stopPropagation()
  }

  function getUserName() {
    return user ? `${user.first_name} ${user.last_name}` : 'Not logged in'
  }
  function getUserRole() {
    return user?.userSource === 'COGNITO'
      ? `(Cognito)`
      : `${
          user?.rights?.includes(UserRightsEnum.CAM_GENERAL_WRITE)
            ? `(Admin)`
            : `(User)`
        }`
  }

  function getAccountName() {
    return `${getUserName()} ${getUserRole()}`
  }

  const closeMenu = () => {
    setState({ showSettingsMenu: false })
  }

  const clickOutside = () => {
    closeMenu()
  }

  const ref = useOutsideClick(clickOutside)

  return (
    <div role="topbar-menu" className={styles.wrapper} ref={wrapperRef}>
      <HelpLink className={cx(styles.circleWrapper, styles.helplink)} />
      <div
        role={'account-menu'}
        className={cx(styles.name)}
        onClick={showHideMenu}
        ref={ref}
      >
        <div
          className={cx(styles.circleWrapper, styles.userMenu, {
            [styles.active]: state.showSettingsMenu
          })}
        >
          <i className={'material-icons'}>account_circle</i>
        </div>

        <span
          className={cx(
            styles.text,
            ProfileSettingsCSSSelectors.loggedUser.value
          )}
        >
          {isOnline ? (
            <>{getAccountName()}</>
          ) : (
            <>
              {`${getUserName()} `}
              <span className={styles.offline}>(Offline)</span>
            </>
          )}
        </span>

        <i className={cx('material-icons', styles.arrow)}>arrow_drop_down</i>
      </div>
      <div
        className={cx(styles.dropdownMenu, {
          [styles.hidden]: state.showSettingsMenu
        })}
      >
        <AccountSettings
          signOut={signOut}
          onOpenAboutUs={onOpenAboutUs}
          user={user}
          history={history}
        />
      </div>
    </div>
  )
}

export default ProfileSettings
